import { render, staticRenderFns } from "./PermissionsListItem.vue?vue&type=template&id=18faa6cd&scoped=true&"
import script from "./PermissionsListItem.vue?vue&type=script&lang=js&"
export * from "./PermissionsListItem.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsListItem.vue?vue&type=style&index=0&id=18faa6cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18faa6cd",
  null
  
)

export default component.exports